import * as React from 'react';
import { withRouter, Link, RouteComponentProps } from 'react-router-dom';
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';

import AttributesQuery from '../../components/Query/Attributes';
import AttributeDetail from './AttributeDetail';
import { Title } from '../../components/Layout/components';
import NotFoundPage from '../NotFound/NotFound';

interface IAttributesTableProps extends RouteComponentProps {
  domain: string;
  attributeId?: string;
}

interface IAttributesTableState {
  attribute?: GQL.IAttribute;
}

class AttributesTable extends React.Component<IAttributesTableProps, IAttributesTableState> {

  constructor(props: IAttributesTableProps) {
    super(props);
  }

  public componentDidMount() {
    if ((this.props as any).onCollapse) {
      (this.props as any).onCollapse(false);
    }
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <AttributesQuery>
            {({ attributes, createAttribute, deleteAttribute, updateAttribute }: any) => {
              return this.renderData(
                attributes,
                createAttribute,
                updateAttribute,
                deleteAttribute,
                attributes.refetch
              );
            }}
          </AttributesQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    attributes: any,
    createAttribute: Function,
    updateAttribute: Function,
    deleteAttribute: Function,
    refetch: Function
  ) {
    if (attributes && !attributes.loading) {

      // formulář
      if (this.props && this.props.attributeId) {
          const selectedObject = attributes.attributes.find((a: GQL.IAttribute) => a.id === this.props.attributeId) || undefined;
          if (this.props.attributeId !== 'new' && !selectedObject) {
              return <NotFoundPage domain={this.props.domain} />
          }
          return (
              <AttributeDetail
                  domain={this.props.domain}
                  languages={attributes.languages}
                  attribute={selectedObject || undefined}
                  onSave={a => this.upsert(a, updateAttribute, createAttribute, refetch)}
                  onCancel={() => this.cancel()}
              />
          );
      }

      return (
        <div>
          <Title>Attributes</Title>
          <Divider />
          <Link className="ant-btn" to={this.getLink('new')}>Create new attribute</Link>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={attributes.attributes}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column title="Title" dataIndex="title" key="title" />
            {/* <Table.Column
              title="Visual"
              dataIndex="manufacturer.display"
              key="manufacturer.display"
              align="center"
              width={100}
              render={(u, row: GQL.IAttribute) => {
                return (
                  <span>
                    {row.isVisual ? (
                      <Icon style={{ color: '#52c41a', fontSize: 20 }} type="check" />
                    ) : (
                      <Icon style={{ fontSize: 20 }} type="close" />
                    )}
                  </span>
                );
              }}
            /> */}
            <Table.Column
              title="Priority"
              dataIndex="priority"
              key="priority"
              align="center"
              width={100}
            />
            <Table.Column
              title="Values"
              dataIndex="values"
              key="values"
              align="center"
              width={100}
              render={(u, row: GQL.IAttribute) => {
                return <span>{(row.values || []).length}</span>;
              }}
            />
            <Table.Column
              title="Actions"
              dataIndex="actions"
              key="actions"
              width={180}
              align="center"
              render={(u: any, row: any) => this.renderActions(u, row, deleteAttribute, refetch)}
            />
          </Table>
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading attributes ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(
    u: any, 
    attribute: GQL.IAttribute, 
    deleteAttribute: Function, 
    refetch: Function
  ) {
    return (
      <div>
        <Link className="ant-btn" type={'dashed'} to={this.getLink(attribute.id)}>
          Edit
        </Link>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(attribute, deleteAttribute, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private setCurrentAttribute(attribute: any) {
    this.setState({ attribute });
  }

  private delete(attribute: GQL.IAttribute, deleteAttribute: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${attribute.title}?`,
      content: (
        <span>
          Are you sure you want to delete attribute <strong>{attribute.title}</strong>
        </span>
      ),
      onOk: () => {
        return deleteAttribute({
          variables: {
            id: attribute.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(
    attribute: GQL.IAttribute, 
    updateAttribute: Function, 
    createAttribute: Function, 
    refetch: Function
  ) {
    if (attribute !== undefined) {
      const variables = {
        id: attribute.id,
        title: attribute.title,
        type: attribute.type || 'text',
        name: attribute.name,
        tags: attribute.tags,
        slug: attribute.slug || {},
        priority: attribute.priority || null,
        definition: attribute.definition,
        isVisual: attribute.isVisual || false,
        values:
          Array.isArray(attribute.values) && attribute.values.length > 0
            ? attribute.values.map(v => {
              return {
                title: v.title,
                slug: v.slug,
                value: v.value != undefined ? v.value : '',
                id: v.id,
                colorHex: v.colorHex
              };
            })
            : []
      };

      if (attribute.id) {
        return updateAttribute({ variables })
          .then(() => this.setCurrentAttribute(null))
          .then(() => refetch())
          .then(() => this.cancel())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Attribute "${variables.title}" has been updated.`
            })
          );
      }

      createAttribute({ variables })
        .then(() => this.setCurrentAttribute(null))
        .then(() => refetch())
        .then(() => this.cancel())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Attribute "${variables.title}" has been created.`
          })
        );
    }
  }

  private getLink(recordId: string | null) {
      return `/${this.props.domain}/application/${recordId ? `attributes/${recordId}` : 'attributes'}`;
  }

  private cancel() {
      this.props.history.push(this.getLink(null));
  }
}

export default withRouter(AttributesTable);


// WEBPACK FOOTER //
// ./src/scenes/Attributes/AttributesTable.tsx